export const libraryImages = {
  img_editor_d: 'assets/svg/icon-d.svg',
  img_editor_a: 'assets/svg/icon-a.svg',
  img_editor_b: 'assets/svg/icon-b.svg',
  img_editor_c: 'assets/svg/icon-c.svg',
  link_icon: 'assets/img/Icon-Link-Button.svg',
  edit_icon: 'assets/img/edit.svg',
  brief_case_icon: 'assets/img/briefcase.svg',
  lib_folder_icon: 'assets/img/lib-folder.svg',
  tick_icon: 'assets/svg/tick.svg',
  lib_filled_folder_icon: 'assets/img/lib-filled-folder.svg',
  lib_file_image: 'assets/img/icons/library/file.png',
  lib_report_icon: 'assets/img/icons/library/report.svg',
  sad_icon: 'assets/new-img/emotion-sad-line.svg',
  link_light_icon: 'assets/new-img/icons/link-white.svg',
  share_bg_icon: 'assets/new-img/icons/share-bg.svg',
  restore_icon: 'assets/img/restore.svg',
  copy_icon: 'assets/img/copy.svg',
  lib_drag_image: 'assets/img/drag-img-1.png',
  pdf_icon: 'assets/img/icons/library/pdf.png',
  png_icon: 'assets/img/icons/library/png.png',
  jpg_icon: 'assets/img/icons/library/jpg.png',
  doc_icon: 'assets/img/icons/library/doc.png',
  xls_icon: 'assets/img/icons/library/xls.png',
  ppt_icon: 'assets/img/icons/library/ppt.png',
  zip_icon: 'assets/img/icons/library/zip.png',
  html_icon: 'assets/img/icons/library/html.png',
  text_icon: 'assets/img/icons/library/txt.png',
  json_icon: 'assets/img/icons/library/json.png',
  xml_icon: 'assets/img/icons/library/xml.png',
  text_file_icon: 'assets/img/icons/library/text-file-font.png',
  library_1_icon: 'assets/menu-customisation-icons/Library/library1.svg',
  library_2_icon: 'assets/menu-customisation-icons/Library/library2.svg',
  library_3_icon: 'assets/menu-customisation-icons/Library/library3.svg',
  library_4_icon: 'assets/menu-customisation-icons/Library/library4.svg',
  library_5_icon: 'assets/menu-customisation-icons/Library/library5.svg',
  library_6_icon: 'assets/menu-customisation-icons/Library/library6.svg',
  library_7_icon: 'assets/menu-customisation-icons/Library/library7.svg',
};
